import { getTranslatedItem } from '@/utils/language.utils';
import { useListAllCheckPoints } from './check-point.hooks';

export const useGetTranslatedCheckPoint = () => {
  const { data: checkPoints } = useListAllCheckPoints();

  return {
    getTranslatedCheckPoint: (checkPointId: string) => {
      const translatedCheckPoints = checkPoints?.data?.find(
        (checkPoint) => checkPoint?.id === checkPointId
      )?.translatedCheckPoints;

      return getTranslatedItem(translatedCheckPoints);
    },
  };
};
